import { render } from "./ItemTypeSelect.vue?vue&type=template&id=d7621238"
import script from "./ItemTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ItemTypeSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script